import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { css } from '@emotion/core';

import { loadHomeProducts } from '../../../redux/modules/homeProducts';
import { loadSidebarPosts } from '../../../redux/modules/posts';
import connectDataFetchers from '../../shared/lib/connectDataFetchers.js';

import ModuleSlider from './HomeModules/ModuleSlider';
import ModuleSpecialOffers from './HomeModules/ModuleSpecialOffers';
import ModuleTagsDiscounts from './HomeModules/ModuleTagsDiscounts';
import ModuleBlogNewsletter from './HomeModules/ModuleBlogNewsletter';
import ModuleLatestBestSellers from './HomeModules/ModuleLatestBestSellers';
import ModuleTimeLimitedDiscount from './HomeModules/ModuleTimeLimitedDiscount';
import ModuleBannerCarousel from './HomeModules/ModuleBannerCarousel';
import ModuleServices from './HomeModules/ModuleServices';
import FeedatyWidget from './FeedatyWidget/FeedatyWidget';

import Assistenza from '../../shared/Icons/Assistenza';
import PuntiRitiro from '../../shared/Icons/PuntiRitiro';
import Spedizione from '../../shared/Icons/Spedizione';
import Pagamenti from '../../shared/Icons/Pagamenti';
import { pushRemarketingEvent } from '../../shared/lib/gaEnhancedEcommerce';
import IubendaCookieSolution from '../../../utils/iubenda';
import {
  ga4ViewItemList,
  ga4ViewPromotion,
} from '../../shared/lib/ga4EnhancedEcommerce';
import {
  fkmxViewItemList,
  fkmxViewPromotions,
} from '../../shared/lib/farmakomMetrics';
import { criteoViewHome } from '../../shared/lib/criteo';
import { gtmToGa4ViewItemList } from '../../shared/lib/gtmEnhancedEcommerce.js';
import { cleanImage } from '../../../utils/images.js';

class Home extends Component {
  componentDidMount() {
    const iubenda = new IubendaCookieSolution(
      this.props.hasIubendaCookieSolution
    );

    // CRITEO TAG
    if (this.props.hasCriteo) {
      // iubenda.proceedIfHasConsent(() => this.renderCriteoTag());
      this.renderCriteoTag();
    }

    // REMARKETING DINAMICO
    if (this.props.hasDynamicRemarketing) {
      pushRemarketingEvent('home');
    }

    if (
      [
        this.props.hasGoogleTagManager,
        this.props.hasGoogleAnalytics4Advanced,
        this.props.hasFarmakomMetrics,
      ].some(t => !!t)
    ) {
      // TRACK LIST - GTM, GA4, FKMX
      this.trackItemsList();
      // TRACK PROMOTION - GTM, GA4, FKMX
      this.trackPromotion();
    }
  }

  componentDidUpdate(oldProps) {
    if (
      (oldProps.discounted || []).length !==
      (this.props.discounted || []).length
    ) {
      const section = {
        listInfo: {
          id: 'special_offers',
          name: 'Special Offers',
        },
        items: this.props.discounted,
      };
      if (this.props.hasGoogleTagManager) {
        gtmToGa4ViewItemList(section.items, section.listInfo);
      }
      if (this.props.hasGoogleAnalytics4Advanced) {
        ga4ViewItemList(section.items, section.listInfo);
      }
      if (this.props.hasFarmakomMetrics) {
        fkmxViewItemList(section.items, section.listInfo);
      }
    }
    if ((oldProps.latest || []).length !== (this.props.latest || []).length) {
      const section = {
        listInfo: {
          id: 'latest_products',
          name: 'Latest Products',
        },
        items: this.props.latest,
      };
      if (this.props.hasGoogleTagManager) {
        gtmToGa4ViewItemList(section.items, section.listInfo);
      }
      if (this.props.hasGoogleAnalytics4Advanced) {
        ga4ViewItemList(section.items, section.listInfo);
      }
      if (this.props.hasFarmakomMetrics) {
        fkmxViewItemList(section.items, section.listInfo);
      }
    }
    if (
      (oldProps.bestSellers || []).length !==
      (this.props.bestSellers || []).length
    ) {
      const section = {
        listInfo: {
          id: 'best_seller_products',
          name: 'Best Seller Products',
        },
        items: this.props.bestSellers,
      };
      if (this.props.hasGoogleTagManager) {
        gtmToGa4ViewItemList(section.items, section.listInfo);
      }
      if (this.props.hasGoogleAnalytics4Advanced) {
        ga4ViewItemList(section.items, section.listInfo);
      }
      if (this.props.hasFarmakomMetrics) {
        fkmxViewItemList(section.items, section.listInfo);
      }
    }
    if ((oldProps.tags || []).length !== (this.props.tags || []).length) {
      this.props.tags.forEach(banner => {
        if (this.props.hasGoogleAnalytics4Advanced) {
          ga4ViewPromotion(banner);
        }
      });
      if (this.props.hasFarmakomMetrics) {
        fkmxViewPromotions(this.props.tags);
      }
    }
    if (
      (oldProps.tagsDiscounts || []).length !==
      (this.props.tagsDiscounts || []).length
    ) {
      this.props.tagsDiscounts.forEach(banner => {
        if (this.props.hasGoogleAnalytics4Advanced) {
          ga4ViewPromotion(banner);
        }
      });
      if (this.props.hasFarmakomMetrics) {
        fkmxViewPromotions(this.props.tagsDiscounts);
      }
    }
  }

  renderCriteoTag = async () => {
    // <!-- Criteo Homepage Tag -->
    const email = (this.props.user && this.props.user.email) || '';
    const zipcode =
      (this.props.user &&
        this.props.user.shipping &&
        this.props.user.shipping.zipcode) ||
      '';

    criteoViewHome(this.props.criteoAccountId, {
      email,
      zipcode,
    });
    // <!-- END Criteo Home Page Tag -->
  };

  trackItemsList = () => {
    const { discounted, latest, bestSellers } = this.props;
    const toTrack = [];
    if (!!(this.props.discounted || []).length) {
      toTrack.push({
        listInfo: {
          id: 'special_offers',
          name: 'Special Offers',
        },
        items: discounted,
      });
    }
    if (!!(this.props.latest || []).length) {
      toTrack.push({
        listInfo: {
          id: 'latest_products',
          name: 'Latest Products',
        },
        items: latest,
      });
    }
    if (!!(this.props.bestSellers || []).length) {
      toTrack.push({
        listInfo: {
          id: 'best_seller_products',
          name: 'Best Seller Products',
        },
        items: bestSellers,
      });
    }
    toTrack.forEach(section => {
      if (this.props.hasGoogleTagManager) {
        gtmToGa4ViewItemList(section.items, section.listInfo);
      }
      if (this.props.hasGoogleAnalytics4Advanced) {
        ga4ViewItemList(section.items, section.listInfo);
      }
      if (this.props.hasFarmakomMetrics) {
        fkmxViewItemList(section.items, section.listInfo);
      }
    });
  };

  trackPromotion = () => {
    const { tags, tagsDiscounts } = this.props;
    const toTrack = [...(tags || []), ...(tagsDiscounts || [])];
    toTrack.forEach(banner => {
      if (this.props.hasGoogleAnalytics4Advanced) {
        ga4ViewPromotion(banner);
      }
      if (this.props.hasFarmakomMetrics) {
        fkmxViewPromotions(tags);
        fkmxViewPromotions(tagsDiscounts);
      }
    });
  };

  render() {
    const {
      isMobile,
      discounted,
      latest,
      bestSellers,
      datiFarmacia,
      loading,
      home,
      siteName,
      logoImage,
      hasBlog,
      tags,
      tagsDiscounts,
      posts,
      feedaty,
      primaryColor,
      secondaryColor,
      uiVariantMenu,
      uiVariantSlider,
      uiVariantSliderTagsSide,
      uiVariantBannerHeader,
      uiVariantBannerPromo,
      uiVariantThumbnail,
      uiVariantServices,
      uiVariantCountdown,
      uiVariantBlogNewsletter,
      uiVariantBannerCarousel,
      position1,
      position2,
      position3,
      position4,
      position5,
      position6,
      position7,
      position8,
      position9,
      hasGoogleAnalytics4Advanced,
      hasGoogleTagManager,
      hasFarmakomMetrics,
    } = this.props;

    const bottomSlides = [
      {
        id: 1,
        seoName: home.slider1Slide1SeoName,
        imgUrl: home.slider1Slide1Image,
        link: home.slider1Slide1Link,
      },
      {
        id: 2,
        seoName: home.slider1Slide2SeoName,
        imgUrl: home.slider1Slide2Image,
        link: home.slider1Slide2Link,
      },
      {
        id: 3,
        seoName: home.slider1Slide3SeoName,
        imgUrl: home.slider1Slide3Image,
        link: home.slider1Slide3Link,
      },
    ];

    const services = [
      {
        id: 1,
        title: 'Aiuto e supporto',
        icon: <Assistenza />,
        url: '/pagine/contattaci',
      },
      {
        id: 2,
        title: 'Condizioni di vendita',
        icon: <PuntiRitiro />,
        url: '/pagine/condizioni-vendita',
      },
      {
        id: 3,
        title: 'Consegne',
        icon: <Spedizione />,
        url: '/pagine/modalita-costi-spedizione',
      },
      {
        id: 4,
        title: 'Pagamenti',
        icon: <Pagamenti />,
        url: '/pagine/pagamenti-accettati',
      },
    ];

    const getHomeModuleByValue = (module, isConsentGiven) => {
      switch (module) {
        case 'slider':
          return (
            <section className="home-module">
              <ModuleSlider
                isMobile={isMobile}
                home={home}
                tags={tags}
                datiFarmacia={datiFarmacia}
                discounted={discounted}
                primaryColor={primaryColor}
                uiVariantBannerHeader={uiVariantBannerHeader}
                uiVariantSlider={uiVariantSlider}
                uiVariantSliderTagsSide={uiVariantSliderTagsSide}
                hasGoogleAnalytics4Advanced={hasGoogleAnalytics4Advanced}
                hasGoogleTagManager={hasGoogleTagManager}
                hasFarmakomMetrics={hasFarmakomMetrics}
              />
            </section>
          );
        case 'special-offers':
          return (
            !!discounted.length && (
              <section className="home-module">
                <ModuleSpecialOffers
                  loading={loading}
                  discounted={discounted}
                  primaryColor={primaryColor}
                  uiVariantThumbnail={uiVariantThumbnail}
                />
              </section>
            )
          );
        case 'tag-discounts':
          return !!tagsDiscounts && tagsDiscounts.length > 0 ? (
            <section className="home-module">
              <ModuleTagsDiscounts
                isMobile={isMobile}
                tagsDiscounts={tagsDiscounts}
                home={home}
                primaryColor={primaryColor}
                uiVariantBannerPromo={uiVariantBannerPromo}
                hasGoogleAnalytics4Advanced={hasGoogleAnalytics4Advanced}
                hasGoogleTagManager={hasGoogleTagManager}
                hasFarmakomMetrics={hasFarmakomMetrics}
              />
            </section>
          ) : null;
        case 'blog-newsletter':
          return (
            <section className="home-module">
              <ModuleBlogNewsletter
                isMobile={isMobile}
                hasBlog={hasBlog}
                home={home}
                posts={posts}
                primaryColor={primaryColor}
                uiVariantBlogNewsletter={uiVariantBlogNewsletter}
              />
            </section>
          );
        case 'latest-bestsellers':
          return (
            <section className="home-module">
              <ModuleLatestBestSellers
                loading={loading}
                latest={latest}
                bestSellers={bestSellers}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                uiVariantMenu={uiVariantMenu}
                uiVariantThumbnail={uiVariantThumbnail}
              />
            </section>
          );
        case 'time-limited-discount':
          return home.timeLimitedDiscount ? (
            <section className="home-module">
              <ModuleTimeLimitedDiscount
                home={home}
                primaryColor={primaryColor}
                uiVariantCountdown={uiVariantCountdown}
                uiVariantThumbnail={uiVariantThumbnail}
              />
            </section>
          ) : null;
        case 'banner-carousel':
          return (
            <section className="home-module">
              <ModuleBannerCarousel
                isMobile={isMobile}
                slides={bottomSlides}
                primaryColor={primaryColor}
                uiVariantBannerCarousel={uiVariantBannerCarousel}
              />
            </section>
          );
        case 'feedaty':
          // return feedaty.enabled && feedaty.widgetId ? (
          return !!feedaty.enabled && !!feedaty.merchantCode ? (
            <section className="feedaty-section">
              <FeedatyWidget
                feedaty={feedaty}
                hasIubendaCookieSolution={this.props.hasIubendaCookieSolution}
              />
            </section>
          ) : null;
        case 'services':
          return (
            <section className="home-module">
              <ModuleServices
                services={services}
                primaryColor={primaryColor}
                uiVariantServices={uiVariantServices}
              />
            </section>
          );
        default:
          return null;
      }
    };

    const homeStyle = css`
      section.home-module {
        padding: 35px 0;

        @media (max-width: 768px) {
          padding: 1rem 0;
        }

        &.feedaty-section {
          padding: 0;
        }

        &:first-of-type {
          padding: 0 0 1rem;
        }
      }
    `;

    return (
      <div className="homepage" css={homeStyle}>
        <Helmet
          title="Home"
          meta={[
            {
              name: 'description',
              content: `${siteName} - Vendita on line di cosmetici, dietetici, integratori alimentari, prodotti per l'igiene, articoli sanitari ed elettromedicali`,
            },
            {
              name: 'keywords',
              content: `${siteName}, Farmacia, Farmacia on line, offerte, confronto prezzi, vendita cosmetici, vendita integratori, vendita elettromedicali, vendita articoli sanitari, vendita prodotti fitoterapici`,
            },
            {
              property: 'og:title',
              content: `Home | ${siteName} - Ecommerce Farmacia`,
            },
            { property: 'og:type', content: 'website' },
            {
              property: 'og:description',
              content: `${siteName} - Vendita on line di cosmetici, dietetici, integratori alimentari, prodotti per l'igiene, articoli sanitari ed elettromedicali`,
            },
            { property: 'og:image', content: cleanImage(logoImage) },
          ]}
        />

        {!!position1 && getHomeModuleByValue(position1)}
        {!!position2 && getHomeModuleByValue(position2)}
        {!!position3 && getHomeModuleByValue(position3)}
        {!!position4 && getHomeModuleByValue(position4)}
        {!!position5 && getHomeModuleByValue(position5)}
        {!!position6 && getHomeModuleByValue(position6)}
        {!!position7 && getHomeModuleByValue(position7)}
        {!!position8 && getHomeModuleByValue(position8)}
        {!!position9 && getHomeModuleByValue(position9)}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isMobile: state.layout.isMobile,
    user: state.user.data,
    discounted: state.homeProducts.data.discounted,
    latest: state.homeProducts.data.recents,
    bestSellers: state.homeProducts.data.bestsellers,
    tags: state.homeProducts.data.tags,
    tagsDiscounts: state.homeProducts.data.tagsDiscounts,
    posts: state.posts.data.latest,
    loading: state.homeProducts.loading,
    home: state.store.data.home,
    siteName: state.store.data.datiFarmacia.siteName,
    datiFarmacia: state.store.data.datiFarmacia,
    logoImage: state.store.data.loghiTemplate.logoImage,
    hasBlog: state.store.data.features.hasBlog,
    hasDynamicRemarketing: state.store.data.features.hasDynamicRemarketing,
    feedaty: {
      enabled: state.store.data.features.hasFeedaty,
      merchantCode: state.store.data.integrazioni.feedaty.merchantCode,
      widgetId: state.store.data.integrazioni.feedaty.widgetId,
      siteKey: state.store.data.integrazioni.feedaty.siteKey,
    },
    primaryColor: state.store.data.loghiTemplate.brandColor,
    secondaryColor: state.store.data.loghiTemplate.secondaryColor,
    uiVariantMenu: state.store.data.uiVariants.menu,
    uiVariantSlider: state.store.data.uiVariants.slider,
    uiVariantSliderTagsSide: state.store.data.uiVariants.sliderTagsSide,
    uiVariantBannerHeader: state.store.data.uiVariants.bannerHeader,
    uiVariantBannerPromo: state.store.data.uiVariants.bannerPromo,
    uiVariantThumbnail: state.store.data.uiVariants.thumbnail,
    uiVariantServices: state.store.data.uiVariants.services,
    uiVariantCountdown: state.store.data.uiVariants.countdown,
    uiVariantBlogNewsletter: state.store.data.uiVariants.blogNewsletter,
    uiVariantBannerCarousel: state.store.data.uiVariants.bannerCarousel,
    position1: state.store.data.uiVariants.position1,
    position2: state.store.data.uiVariants.position2,
    position3: state.store.data.uiVariants.position3,
    position4: state.store.data.uiVariants.position4,
    position5: state.store.data.uiVariants.position5,
    position6: state.store.data.uiVariants.position6,
    position7: state.store.data.uiVariants.position7,
    position8: state.store.data.uiVariants.position8,
    position9: state.store.data.uiVariants.position9,
    hasCriteo: state.store.data.features.hasCriteo,
    criteoAccountId: state.store.data.integrazioni.criteo.accountId,
    hasIubendaCookieSolution:
      state.store.data.features.hasIubendaCookieSolution,
    hasGoogleAnalytics4Advanced: !!state.store.data.features
      .hasGoogleAnalytics4Advanced,
    hasGoogleTagManager: !!state.store.data.features.hasGoogleTagManager,
    hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
  };
}

export default connect(mapStateToProps)(
  connectDataFetchers(Home, [loadHomeProducts, loadSidebarPosts])
);
